import React, { useState } from 'react';
import { gujaratDistricts, DistrictPath, apmcData } from './GujaratPaths';

const GujaratMapIndia: React.FC = () => {
  const [hoveredDistrict, setHoveredDistrict] = useState<string>('');
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPosition({ 
      x: e.clientX - rect.left, 
      y: e.clientY - rect.top 
    });
  };

  return (
    <div className="position-relative w-100 h-100">
      {/* APMC Hover Box */}
      {hoveredDistrict && (
        <div 
          className="position-absolute bg-white border rounded shadow"
          style={{ 
            left: `${tooltipPosition.x + 15}px`, 
            top: `${tooltipPosition.y + 15}px`,
            zIndex: 1000,
            pointerEvents: 'none',
            maxWidth: '250px',
            padding: '10px 12px'
          }}
        >
          <strong style={{ fontSize: '0.9rem', display: 'block', marginBottom: '6px' }}>
            {hoveredDistrict}
          </strong>
          {apmcData[hoveredDistrict] && apmcData[hoveredDistrict].length > 0 ? (
            <ul style={{ 
              fontSize: '0.75rem', 
              margin: 0, 
              paddingLeft: '18px',
              listStyleType: 'disc'
            }}>
              {apmcData[hoveredDistrict].map((apmc, index) => (
                <li key={index} style={{ marginBottom: '2px' }}>
                  {apmc}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>No data</p>
          )}
        </div>
      )}

      {/* Map SVG */}
      <div 
        className="w-100 h-100"
        onMouseMove={handleMouseMove}
        style={{ cursor: 'pointer' }}
      >
        <svg
          version="1.1"
          xmlSpace="preserve"
          width="100%"
          height="100%"
          viewBox="19 18 250 175"
          preserveAspectRatio="xMidYMid meet"
        >
          <defs>
            <style type="text/css">{`
              .map-district {
                fill: #089f2bba;
                stroke-width: 0.5px;
                stroke: #fff;
                cursor: pointer;
                
              }

              .map-district:hover {
                fill: #ff6f00;
              }
            `}</style>
          </defs>

          <g id="Gujaratthree">
            {gujaratDistricts.map((district: DistrictPath) => (
              <path
                key={district.id}
                className="map-district"
                d={district.path}
                onMouseEnter={() => setHoveredDistrict(district.name)}
                onMouseLeave={() => setHoveredDistrict('')}
              >
                <title>{district.name}</title>
              </path>
            ))}
          </g>
        </svg>
      </div>
    </div>
  );
};

export default GujaratMapIndia